import React, { lazy, Suspense } from "react";

import DefaultLoader from "../../utilities/loaders/DefaultLoader";
const PendingRequestsContent = lazy(() => import("./PendingRequestsContent"));

const PendingRequests = () => {
    return (
        <Suspense fallback={<DefaultLoader />}>
            <PendingRequestsContent />
        </Suspense>
    );
};

export default PendingRequests;
